// src/utils/initials.js
//
// Derive display initials from a person's full display name.
//
//   "Dev Admin"                   → "DA"
//   "Alexandra Hernandez-Williams" → "AH" (first + last word; hyphens are word chars)
//   "Dev"                         → "D"
//   "" / null / undefined / 42   → "?"

/**
 * @param {unknown} name
 * @returns {string}
 */
export function getInitials(name) {
  if (!name || typeof name !== "string") return "?";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}
